import ServiceTemplate from '@/components/ServiceTemplate';

export default function DMCACompliance() {
  const data = {
    title: 'DMCA Compliance Services',
    subtitle: 'Digital Millennium Copyright Act compliance and safe harbor protection for online platforms.',
    overviewTitle: 'Understanding DMCA Compliance',
    overviewImage: 'https://images.unsplash.com/photo-1556155092-490a1ba16284',
    description: [
      'The Digital Millennium Copyright Act (DMCA) provides safe harbor protection for online service providers from copyright liability, but only if they comply with specific requirements including designating an agent and implementing takedown procedures.',
      'Our DMCA compliance service helps websites, platforms, and online businesses establish required policies, designate agents with the Copyright Office, and implement compliant takedown procedures.',
      'We ensure your business is properly protected from copyright liability while maintaining DMCA safe harbor status.'
    ],
    benefits: [
      { title: 'Safe Harbor Protection', description: 'Protect against copyright infringement liability.' },
      { title: 'Agent Designation', description: 'Register DMCA agent with Copyright Office.' },
      { title: 'Policy Development', description: 'Create compliant DMCA policies.' },
      { title: 'Takedown Procedures', description: 'Implement proper notice and takedown process.' },
      { title: 'Counter-Notice Process', description: 'Establish procedures for counter-notifications.' },
      { title: 'Ongoing Compliance', description: 'Maintain continuous DMCA compliance.' }
    ],
    process: [
      { title: 'Initial Setup & Assessment', description: 'Comprehensive evaluation of current situation and establishment of service framework.' },
      { title: 'Implementation & Management', description: 'Execute ongoing services with regular monitoring, reporting, and optimization.' },
      { title: 'Review & Strategic Guidance', description: 'Periodic reviews with strategic recommendations for continuous improvement.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Single work registration',
        price: '$199',
        period: '+ filing fees ($45-$65)',
        features: [
          'Single work registration',
          'Copyright Office filing',
          'Application preparation',
          'Certificate delivery',
          'Email support',
          'Standard processing'
        ]
      },
      {
        name: 'Professional',
        description: 'Multi-work package',
        price: '$399',
        period: '+ filing fees',
        featured: true,
        features: [
          'Up to 5 works registration',
          'Expedited filing available',
          'Comprehensive documentation',
          'Priority processing',
          'Copyright monitoring (6 months)',
          'Phone support',
          'Enforcement consultation'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Portfolio management',
        price: '$799',
        period: '+ filing fees',
        features: [
          'Unlimited registrations',
          'Portfolio strategy planning',
          'Ongoing monitoring',
          'DMCA takedown services',
          'Infringement detection',
          'Legal representation',
          'Dedicated account manager'
        ]
      }
    ],
    faqs: [
      { question: 'What is DMCA safe harbor?', answer: 'Safe harbor protects online service providers from copyright liability for user-posted content if they meet DMCA requirements.' },
      { question: 'Who needs DMCA compliance?', answer: 'Websites and platforms hosting user-generated content, including forums, marketplaces, social networks, and content hosting services.' },
      { question: 'What is a designated agent?', answer: 'A person or entity designated to receive copyright infringement notifications, registered with the Copyright Office.' },
      { question: 'How do takedown notices work?', answer: 'Copyright owners send notices identifying infringing content. Service providers must expeditiously remove or disable access upon receiving valid notice.' },
      { question: 'What about counter-notifications?', answer: 'Users can file counter-notices if they believe content was wrongly removed. Content may be restored after 10-14 days unless copyright owner files suit.' },
      { question: 'What is repeat infringer policy?', answer: 'Service providers must have and implement policies for terminating accounts of users who repeatedly infringe copyrights.' },
      { question: 'How often must agent be updated?', answer: 'Agent designations must be updated every 3 years with the Copyright Office, plus whenever contact information changes.' },
      { question: 'What if I don\'t comply?', answer: 'Non-compliance means losing safe harbor protection, exposing your business to direct copyright infringement liability for user content.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
